import Vue from 'vue'
import LangRouter from 'vue-lang-router'
import { getAuth } from '@/services/authService'
import HomeView from '../views/HomeView.vue'
import WhitelabelView from '../views/WhitelabelView.vue'
import AuthView from '../views/AuthView.vue'
import RegisterView from '../views/RegisterView.vue'
import OrdersView from '@/views/OrdersView.vue'
import GuideDocuments from '@/views/GuideDocuments.vue'
import AuthExit from '@/components/auth/AuthLogout.vue'
import AuthRedirect from '@/components/auth/AuthRedirect.vue'
import AccountSettings from '@/views/AccountSettings.vue'
import MainStore from '@/views/MainStore.vue'
import AllStores from '@/views/AllStores.vue'
import Products from '@/views/Products.vue'
import Sales from '@/views/Sales.vue'
import AccountView from '@/views/AccountView'
import IntegrationsView from '@/views/IntegrationsView'
import MarketingView from '@/views/MarketingView'
import FinTableView from '@/views/FinTableView'
import NotificationsView from '@/views/NotificationsView'
import DashboardView from '@/views/DashboardView.vue'
import HelpView from '@/views/HelpView.vue'
import translations from '../lang/translations'
import localizedURLs from '../lang/localized-urls'
import PartnerPending from '@/views/PartnerPending'
import ReportsView from '@/views/ReportsView'
import DashboardOrders from '@/components/dashboard/DashboardOrders'
import StoreObject from '@/components/marketing/StoreObject.vue'
import PrivacyPolicy from '@/views/PrivacyPolicy.vue'
import WhiteBoard from '@/views/WhiteBoard.vue'
import PortalHub from '@/views/PortalHub.vue'
import Management from '@/views/Management.vue'
import Inventory from '@/views/Inventory.vue'
import AppRegularView from '@/views/AppRegularView.vue'
import QuotationsRegularView from '@/views/QuotationsRegularView.vue'
import Comercial from '@/views/Comercial.vue'
import CreateProfile from '@/components/management/CreateProfile.vue'


Vue.use(LangRouter, {
  defaultLanguage: 'pt',
  translations,
  localizedURLs,
})

const routes = [
  {
    path: '/teste',
    component: DashboardOrders
  },
  {
    path: '/app',
    component: AppRegularView,
    meta: {
      requiresAuth: true,
      title: "Administração Media Trade",
    },
    children: [
      {
        path: 'home',
        component: WhiteBoard
      },
      {
        path: 'help',
        component: HelpView,
        meta: {
          title: "Ajuda - Canal do Veículo"
        }
      }
      
    ]
    
  },
  {
    path: '/welcome',
    component: PortalHub
  },
  {
    path: '/politicas-de-cookie-e-privacidade',
    component: PrivacyPolicy
  },
  {
    path: '/importer',
    component: StoreObject
  },
  {
    path: '/',
    component: HomeView,
    meta: {
      checkAuth: true
    }
  },
  {
    path: '/whitelabel',
    component: WhitelabelView
  },
  {
    path: '/entrar',
    component: AuthView
  },
  {
    path: '/confirmacao/:token',
    component: AuthView
  },
  {
    path: '/redirect/:token',
    component: AuthRedirect
  },
  {
    path: '/cadastrar',
    component: RegisterView
  },
  {
    path: '/cadastrar/:p',
    component: RegisterView
  },
  {
    name: 'Logout',
    path: '/sair',
    component: AuthExit
  },
  {
    path: '/partner-pending',
    component: PartnerPending
  },
  {
    path: '/welcome',
    component: PortalHub
  },
  {
    path: '/pedidos',
    component: OrdersView,
    meta: {
      requiresAuth: true,
      title: "Administração Media Trade"
    }
  },
  {
    path: '/account/whitelabel/:tab',
    component: AccountView,
    meta: {
      requiresAuth: true,
      requiresW: true,
      title: "Administração Media Trade",
    },
  },
  {
    path: '/account/whitelabel',
    component: AccountView,
    meta: {
      requiresAuth: true,
      requiresW: true,

      title: "Administração Media Trade",
    },
  },

  {
    path: '/conta',
    component: AccountSettings,
    meta: {
      requiresAuth: true,
      title: "Administração Media Trade",
    },
    children: [
      {
        path: 'configuracoes',
        component: AccountSettings,
        meta: {
          requiresAuth: true
        }
      },
      {
        path: 'configuracoes/:tab',
        component: AccountSettings,
        meta: {
          requiresAuth: true
        }
      },
    ]
  },
  {
    path: '/reports',
    component: ReportsView,
    meta: {
      requiresAuth: true,
      requiresW: true,

      title: "Reports - The Media Trade",
    },
    children: [
      {
        path: ':tab',
        component: ReportsView,
        meta: {
          requiresAuth: true,
          requiresW: true
        }
      }
    ]
  },
  {
    path: '/guide',
    component: GuideDocuments,
    meta: {
      requiresAuth: true,
      title: "Guia de Uso"
    }
  },
  {
    path: '/dashboard',
    component: DashboardView,
    meta: {
      requiresAuth: true,
      requiresW: true,

      title: "Overview - Dashboard - The Media Trade",
    },
    children: [
      {
        path: ':tab',
        component: DashboardView,
        meta: {
          requiresW: true,

          requiresAuth: true
        }
      },

    ]
  },
  {
    path: '/settings',
    component: MainStore,
    meta: {
      requiresAuth: true,
      requiresW: true,
      title: "Overview - Store Configuration - The Media Trade"
    }
  },
  {
    path: '/notifications',
    component: NotificationsView,
    meta: {
      requiresAuth: true,
      requiresW: true,
      title: "Notifications - Store Configuration - The Media Trade"
    }
  },

  {
    path: '/settings/:tab',
    component: MainStore,
    meta: {
      requiresAuth: true,
      requiresW: true,
      title: "Overview - Store Configuration - The Media Trade"
    }
  },
  {
    path: '/all-stores',
    component: AllStores,
    meta: {
      requiresW: true,
      requiresAuth: true,
      title: "Overview - All Stores - The Media Trade"
    }
  },
  {
    path: '/products/:tab',
    component: Products,
    meta: {
      requiresAuth: true,
      title: "Overview - Products - The Media Trade"
    }
  },

  {
    path: '/app/management/:tab',
    component: Management,
    meta: {
      requiresAuth: true,
      title: "Overview - Management - The Media Trade"
    }
  },

  {
    path: '/app/management/profiles/create',
    component: CreateProfile,
    meta: {
      requiresAuth: true,
      title: "Create Profile - Management - The Media Trade"
    }
  },

  {
    path: '/app/management/profiles/:profileId',
    component: Management,
    props: route => ({ profileId: route.params.profileId }),
    meta: {
      requiresAuth: true,
      title: "Profile Details - Management - The Media Trade"
    }
  },

  {
    path: '/app/inventory/:tab',
    component: Inventory,
    meta: {
      requiresAuth: true,
      title: "Overview - Inventory - The Media Trade"
    }
  },



  {
    path: '/app/comercial/:tab',
    component: Comercial,
    meta: {
      requiresAuth: true,
      title: "Overview - Comercial - The Media Trade"
    }
  },

  {
        path: '/app/comercial/cotacoes/:gridId',
        component: QuotationsRegularView
      },

  {
    path: '/sales/:tab/:id?',
    component: Sales,
    meta: {
      requiresAuth: true,
      title: "Overview - Sales - The Media Trade"
    }
  },

  {
    path: '/integrations',
    component: IntegrationsView,
    meta: {
      requiresAuth: true,
      title: "Intgrations - The Media Trade"
    }
  },
  {
    path: '/marketing-and-seo/:tab',
    component: MarketingView,
    meta: {
      requiresAuth: true,
      title: "Marketing & SEO - The Media Trade"
    }
  },
  {
    path: '/financial/:tab',
    component: FinTableView,
    meta: {
      requiresAuth: true,
      title: "Financeiro - The Media Trade"
    }
  },


  {
    path: '/about',
    name: 'about',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/AboutView.vue')
  }
]

const router = new LangRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach((to, from, next) => {
  const currentUser = getAuth()
  const requiresAuth = to.matched.some(record => record.meta.requiresAuth)
  const requiresW = to.matched.some(record => record.meta.requiresW)
  const checkAuth = to.matched.some(record => record.meta.checkAuth)

  const r = currentUser?.whitelabel?.w ?? null

  if (checkAuth && currentUser) {
    next(r?.enabled ? '/dashboard' : '/app/home')
    return
  }

  if (!requiresAuth) {
    next()
    return
  }

  if (!currentUser) {
    next(`/entrar?notallowed=1&r=${encodeURIComponent(to.fullPath)}`)
    return
  }

  if (requiresW && !r?.enabled) {
    next('/app/home')
    return
  }

  next()
})

export default router
